export default __webpack_public_path__ + "static/media/twoRoundArrow.9404b7d6.svg";